interface Package {
    name: string;
    emoji: string;
    hours: number;
    kids: number;
    price: string;
    deposit: string;
    pizzaPrice: string;
}

const PriceComp = () => {

    const commonFeatures: string[] = [
        "Hakuna Matata pozivnice",
        "Odgojitelj + animator",
        "Grickalice, keksi i negazirani sokovi",
        "Posebni poklon za slavljenika",
        "Osnovni poklon za svakog pozvanog gosta",
    ];

    const packages: Package[] = [
        { name: "Paket Panda", emoji: "🐼", hours: 2, kids: 15, price: "200,00€", deposit: "50,00€", pizzaPrice: "30,00€" },
        { name: "Paket Slon", emoji: "🐘", hours: 2, kids: 25, price: "220,00€", deposit: "60,00€", pizzaPrice: "40,00€" },
        { name: "Paket Žirafa", emoji: "🦒", hours: 3, kids: 15, price: "250,00€", deposit: "60,00€", pizzaPrice: "30,00€" },
        { name: "Paket Lav", emoji: "🦁", hours: 3, kids: 25, price: "270,00€", deposit: "70,00€", pizzaPrice: "40,00€" },
    ];

    return (
        <div id="main">
            <section id="price" className="tiles">
                {packages.map((pkg, index) => (
                    <article className="rest" key={index}>
                        <header className="major">
                            <h3>
                                <a
                                    href="#contact"
                                    className="link"
                                    aria-label={`Rezerviraj ${pkg.name}`}
                                >
                                    {pkg.name} {pkg.emoji}
                                </a>
                            </h3>
                            <ul className="custom-list">
                                <li><strong>{pkg.hours}h zabave</strong></li>
                                <li><strong>Do {pkg.kids} djece</strong></li>
                                {commonFeatures.map((feature, i) => (
                                    <li key={i}>{feature}</li>
                                ))}
                                <li>Pizze: {pkg.pizzaPrice} (opcionalno)</li>
                                <li>Rođendanska torta sa svjećicama i ukrasima: 25,00€ (opcionalno)</li>
                            </ul>
                            <p className="price">
                                <strong>{pkg.price}</strong> (polog: {pkg.deposit})
                            </p>
                        </header>
                    </article>
                ))}
                <article className="rest">
                    <header className="major">
                        <h3>
                            <a
                                href="#contact"
                                className="link"
                                aria-label="Kontakt za dodatne opcije"
                            >
                                Dodatne opcije &#129417;
                            </a>
                        </h3>
                        <ul className="custom-list">
                            <li>Mogućnost zajedničke proslave za braću i sestre</li>
                            <li>Zajednička proslava za dvoje prijatelja iz razreda ili vrtića</li>
                        </ul>
                    </header>
                </article>
            </section>
        </div>
    );
};

export default PriceComp;